import { render, staticRenderFns } from "./Films.vue?vue&type=template&id=80313ac2"
import script from "./Films.vue?vue&type=script&lang=js"
export * from "./Films.vue?vue&type=script&lang=js"
import style0 from "./Films.vue?vue&type=style&index=0&id=80313ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports